<template>
  <span>
    {{ text }}
  </span>
</template>

<script>
export default {
  props: ["risk"],
  computed: {
    text() {
      if (!this.risk?.category) {
        return "";
      }
      const category = this.risk.category;
      if (category == "ADMINISTRATIVE") {
        return this.$t("risk.category.administrative");
      }
      if (category == "TECHNICAL") {
        return this.$t("risk.category.technical");
      }
      if (category == "LEGAL") {
        return this.$t("risk.category.legal");
      }
    },
  },
};
</script>

<style></style>
